export default __webpack_public_path__ + "static/media/Plissee 22 mm reversibel ausmessen.53daa6a5.jpg";